import React, { type ReactElement, type ReactNode } from 'react';
import { Theme, styled } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface BlankLayoutProps {
  children: ReactNode;
  backgroundColor?: string;
}

const CustomContainer = styled(Container)<{ backgroundColor?: string }>(({ theme, backgroundColor }) => ({
  backgroundColor: backgroundColor || theme.palette.grey[100],
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingBottom: '15px',
  alignItems: 'center',
  paddingTop: '24px',
}));

const FooterNote = styled(Typography)(({ theme }: { theme: Theme }) => ({
  textAlign: 'center',
  color: `${theme.palette.info.main}66`,
  paddingBottom: 16,
}));

function BlankLayout({ children, backgroundColor }: BlankLayoutProps): ReactElement {
  return (
    <CustomContainer maxWidth={false} backgroundColor={backgroundColor}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 'auto', mx: 'auto' }}>
        {children}
      </Box>
      <FooterNote variant="subtitle2">&copy; {new Date().getFullYear()} Porolis Technologies Pte Ltd</FooterNote>
    </CustomContainer>
  );
}

export default BlankLayout;
